import type { Metadata, Viewport } from 'next';

import { BASE_URL } from './env';

/** 고향사랑 들어오면서 새로 추가된 데이터들 */

const TITLE = '고향사랑기부제 웰로';
const DESCRIPTION =
  '고향사랑기부제 웰로 - 5,200만 전국민 개인맞춤형 정책서비스';
const KEYWORDS =
  '웰로,고향사랑기부제,소득공제,세액공제,기부답례품,정책,취업,육아,정부,보조금,혜택';
const APP_LINKS = {
  ios: {
    app_store_id: '6444814937',
    url: 'https://apps.apple.com/kr/app/%EC%9B%B0%EB%A1%9C/id6444814937',
    app_name: '고향사랑기부제 웰로 - 5,200만 전국민 개인맞춤형 정책서비스',
  },
  android: {
    package: 'com.wello.welfarehello',
    app_name: '고향사랑기부제 웰로 - 5,200만 전국민 개인맞춤형 정책서비스',
    url: 'https://play.google.com/store/apps/details?id=com.wello.welfarehello',
  },
};

export const DEFAULT_META = {
  generator: 'Next.js',
  applicationName: '웰로',
  metadataBase: new URL(BASE_URL),
  appLinks: APP_LINKS,
  manifest: '/manifest.json',
  keywords: KEYWORDS,
  title: TITLE,
  authors: [
    {
      name: '주식회사 웰로',
      url: 'https://www.wello.info',
    },
  ],
  publisher: '주식회사 웰로',
  description: DESCRIPTION,
  icons: {
    shortcut: '/favicon.ico',
  },
  openGraph: {
    images: 'https://cdn.welfarehello.com/common/ogimg.png',
    title: '웰로 - 5,200만 국민을 위한 개인 맞춤형 정책 추천 서비스',
    siteName: '웰로',
    type: 'website',
  },
} satisfies Metadata;

export const DEFAULT_VIEWPORT = {
  width: 'device-width',
  initialScale: 1,
  maximumScale: 1,
  userScalable: false,
  themeColor: '#ffffff',
} satisfies Viewport;
